// Enables native beforeunload dialog (once)
let beforeUnloadHandler: ((e: BeforeUnloadEvent) => void) | null = null;

export function enableBeforeUnload(message?: string): void {
  if (typeof window === "undefined") return;
  if (beforeUnloadHandler) return;

  beforeUnloadHandler = (e: BeforeUnloadEvent) => {
    e.preventDefault();
    e.returnValue = message || "You won't be able to log the call. Changes may be lost.";
    return e.returnValue;
  };

  window.addEventListener("beforeunload", beforeUnloadHandler, { capture: true });
}

// Disables beforeunload dialog
export function disableBeforeUnload(): void {
  if (typeof window === "undefined") return;
  if (!beforeUnloadHandler) return;
  window.removeEventListener("beforeunload", beforeUnloadHandler, { capture: true } as any);
  beforeUnloadHandler = null;
}
